export const ReferralCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  TopRow: {
    flow: 'x',
    align: 'center space-between',
    DirectionBadge: {
      tag: 'span',
      text: (el, s) => s.direction || 'Inbound',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => (s.direction === 'Outbound') ? 'teal.15' : 'blue.15',
      color: (el, s) => (s.direction === 'Outbound') ? 'teal' : 'blue'
    },
    StatusBadge: {
      tag: 'span',
      text: (el, s) => s.referralStatus || 'Sent',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const st = s.referralStatus || 'Sent'
        if (st === 'Sent') return 'blue.15'
        if (st === 'Scheduled') return 'amber.15'
        if (st === 'Completed') return 'green.15'
        if (st === 'LetterSent') return 'teal.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.referralStatus || 'Sent'
        if (st === 'Sent') return 'blue'
        if (st === 'Scheduled') return 'amber'
        if (st === 'Completed') return 'green'
        if (st === 'LetterSent') return 'teal'
        return 'inkMuted'
      }
    }
  },
  PatientName: { text: (el, s) => s.patientName || 'Patient Name', fontSize: 'A', fontWeight: '600', color: 'inkText' },
  ReferringDoctor: { text: (el, s) => s.referringDoctor || 'Unknown', fontSize: 'Z', color: 'inkMuted' },
  Specialty: { text: (el, s) => s.specialty || 'Oral Surgery', fontSize: 'Z', color: 'teal', fontWeight: '500' },
  Reason: { text: (el, s) => s.reason || 'Impacted wisdom teeth', fontSize: 'Z', color: 'inkSubtle' },
  DateSent: { text: (el, s) => 'Sent: ' + (s.dateSent || '--'), fontSize: 'Y', color: 'inkSubtle' },
  GenerateLetterBtn: {
    extends: 'Button',
    text: '{{ generateLetter | polyglot }}',
    fontSize: 'Y',
    padding: 'Y Z',
    round: 'Z',
    background: 'teal',
    color: 'white',
    fontWeight: '600',
    cursor: 'pointer',
    alignSelf: 'flex-start'
  }
}
